<form [formGroup]="clientCreationForm">
    <div class="client-creation">
        <div class="client-creation__start">
            <div class="client-creation__start__header">
                <span class="client-creation__start__header__title">Nuevo cliente</span>
                <button mat-icon-button data-testid="client-creation-header-btn-close" (click)="dialogRef.close(false)"><mat-icon>close</mat-icon></button>
            </div>
            <div class="client-creation__start__form">
                <p class="client-creation__start__form__title">Información General</p>
                <mat-form-field appearance="outline">
                    <mat-label>Empresa</mat-label>
                    <mat-select toggleClassOnValue data-testid="client-creation-body-select-tenant" formControlName="tenant">
                        @if (tenantControl.value != '') {
                            <mat-select-trigger>
                                <div class="container-trigger-client-creation-tenant">
                                    <mat-icon [style]="'color: '+tenantControl.value.tenantColor">circle</mat-icon>
                                    <span>{{ tenantControl.value.tenantName }}</span>
                                </div>
                            </mat-select-trigger>
                        }
                        @for (tenant of lstTenants; track tenant.tenantId) {
                            <mat-option [attr.data-testid]="'client-creation-body-option-'+tenant.tenantId" [value]="tenant">{{tenant.tenantName}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Documento de identidad</mat-label>
                    <input matInput toggleClassOnValue data-testid="client-creation-body-input-document" formControlName="document">
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Nombres</mat-label>
                    <input matInput toggleClassOnValue data-testid="client-creation-body-input-first-name" formControlName="firstName">
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Apellidos</mat-label>
                    <input matInput toggleClassOnValue data-testid="client-creation-body-input-last-name" formControlName="lastName">
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Correo electrónico</mat-label>
                    <input matInput toggleClassOnValue data-testid="client-creation-body-input-email" formControlName="email">
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Teléfono de contacto</mat-label>
                    <input matInput toggleClassOnValue data-testid="client-creation-body-input-phone" formControlName="phone">
                </mat-form-field>
            </div>
        </div>
        <div class="client-creation__footer">
            <button mat-flat-button [disabled]="formInvalid() || searchState.isCreating()" data-testid="client-creation-body-btn-save-client" (click)="creationClient()">GUARDAR</button>
            <button mat-stroked-button [disabled]="formInvalid() || searchState.isCreating()" data-testid="client-creation-body-btn-cancel" (click)="dialogRef.close(false)">CANCELAR</button>
        </div>
    </div>
</form>
